import React, { useState, useEffect } from 'react'
import Modal from 'components/modal'
import TimeRange from 'components/timeRange'
import moment from 'moment'
import { convert12to24Hours, convert24to12Hours } from 'shared/helpers/functional'
import { localizedDateFormatter, getUserTimeZone, localizedTranslate, parseTimeZone } from 'assets/localization'
import { timezoneAbbreviationLabel } from 'shared/helpers/user'

import 'less/add-manage-time-range-modal.less'

const AddManageRangeTimeModal = props => {
  const [startTimeHours, setStartTimeHours] = useState('01')
  const [startTimeMinutes, setStartTimeMinutes] = useState('00')
  const [endTimeHours, setEndTimeHours] = useState('01')
  const [endTimeMinutes, setEndTimeMinutes] = useState('00')
  const [startTimeAmPm, setStartTimeAmPm,] = useState(0)
  const [endTimeAmPm, setEndTimeAmPm,] = useState(0)
  const [enableSubmit, setEnableSubmit,] = useState(false)
  const [showErrors, setshowErrors] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  const avModerators = props.avModerators
  const startTimeFormatted = props.selectedModeratorTimeRange.startTime && convert24to12Hours(props.selectedModeratorTimeRange.startTime) // 12 hours fromat
  const endTimeFormatted = props.selectedModeratorTimeRange.endTime && convert24to12Hours(props.selectedModeratorTimeRange.endTime ) // 12 hours fromat

  useEffect(() => {
    if (props.selectedModeratorTimeRange.startTime && props.selectedModeratorTimeRange.endTime) {
      setStartTimeHours(startTimeFormatted.substring(0, 2))
      setStartTimeMinutes(startTimeFormatted.substring(3, 5))
      setEndTimeHours(endTimeFormatted.substring(0, 2))
      setEndTimeMinutes(endTimeFormatted.substring(3, 5))
      setStartTimeAmPm(startTimeFormatted.substring(6, 8) === 'AM' ? 0 : 1)
      setEndTimeAmPm(endTimeFormatted.substring(6, 8) === 'AM' ? 0 : 1)
    } else {
      setStartTimeHours('01')
      setStartTimeMinutes('00')
      setEndTimeHours('01')
      setEndTimeMinutes('00')
      setStartTimeAmPm(0)
      setEndTimeAmPm(0)
      setEnableSubmit(false)
    }
  }, [props.selectedModeratorTimeRange.startTime])

  useEffect(() => {
    setshowErrors(false)
  }, [startTimeHours, startTimeMinutes, startTimeAmPm, endTimeHours, endTimeMinutes, endTimeAmPm])

  useEffect(() => {
    const newStartTime = startTimeHours + ':' + startTimeMinutes + `${startTimeAmPm === 0 ? ' AM' : ' PM'}` // 12 hours format
    const newEndTime = endTimeHours + ':' + endTimeMinutes + `${endTimeAmPm === 0 ? ' AM' : ' PM'}` // 12 hours format
    if ((newStartTime === "01:00 AM" && newEndTime === "01:00 AM" && !startTimeFormatted && !endTimeFormatted)) {
      setEnableSubmit(false)
    }
    else if (((newStartTime === startTimeFormatted)) && ((newEndTime === endTimeFormatted))) {
      setEnableSubmit(false)
    } else {
      setEnableSubmit(true)
    }
  }, [startTimeHours, startTimeMinutes, startTimeAmPm, endTimeHours, endTimeMinutes, endTimeAmPm])

  const handleSubmit = () => {
    const startTime = startTimeHours + ':' + startTimeMinutes + `${startTimeAmPm === 0 ? ' AM' : ' PM'}` // 12 hours format
    const endTime = endTimeHours + ':' + endTimeMinutes + `${endTimeAmPm === 0 ? ' AM' : ' PM'}` // 12 hours format

    const newStartTime24hours =  convert12to24Hours(startTime) 
    const newEndTime24hours = convert12to24Hours(endTime)

    if (((startTime === startTimeFormatted)) && ((endTime === endTimeFormatted))) {
      setshowErrors(false)
    } else if (startTime === endTime) {
      setshowErrors(true)
      setErrorMessage(props.t('time.range.modal.error.equal'))
    } 
    else if (newStartTime24hours > newEndTime24hours) {
      setshowErrors(true)
      setErrorMessage(props.t('time.range.modal.error.greater'))
    } 
    else {
      setshowErrors(false)
        avModerators.forEach(function (item) {
          if (item.id === props.moderatorId) {
            item.startTime = newStartTime24hours
            item.endTime = newEndTime24hours
            item.timezone = props.selectedModeratorTimeRange.timezone ? props.selectedModeratorTimeRange.timezone : props.getUserTimeZone
          }
        });
      props.onSubmit({ selectedModeratorTimeRange : {startTime: newStartTime24hours, endTime: newEndTime24hours }, moderatorId: props.moderatorId, projectId: props.projectId, timezone: props.selectedModeratorTimeRange.timezone })
      setEnableSubmit(false)
    }
  }
  return (
    <Modal
      title={"ADD/MANAGE TIME RANGE"}
      isOpen={props.isOpen}
      className="confirmation-modal add-manage-time-range-modal"
      type="modal"
      autoFocusSubmit={false}
      submitBtnText="Accept"
      onCancel={props.onCancel}
      onSubmit={handleSubmit}
      enableSubmit={enableSubmit}
      isSubmitting={props.isSubmitting}
    >
      <div className="add-manage-time-range-modal-body">
        <div className='text'> {` ${props.t('add.time.range.modal.message')}`} </div>
        <div className='text-note'>{props.t('add.time.range.modal.message.note')}</div>
        
        <TimeRange label={`Start Time (${timezoneAbbreviationLabel(props.selectedModeratorTimeRange.timezone)})`}
          onChangeHours={newStartHours => setStartTimeHours(newStartHours.value)}
          onChangeMinutes={newStartMinutes => setStartTimeMinutes(newStartMinutes.value)}
          timeHours={startTimeHours}
          timeMinutes={startTimeMinutes}
          name={'start-time'}
          selectedToggle={startTimeAmPm}
          onToggle={(val) => setStartTimeAmPm(val)}
          showErrors={showErrors}
          errorMessage={errorMessage}
        >
        </TimeRange>
        <TimeRange label={`End Time (${timezoneAbbreviationLabel(props.selectedModeratorTimeRange.timezone)})`}
          onChangeHours={newEndHours => setEndTimeHours(newEndHours.value)}
          onChangeMinutes={newEndMinutes => setEndTimeMinutes(newEndMinutes.value)}
          timeHours={endTimeHours}
          timeMinutes={endTimeMinutes}
          name={'end-time'}
          selectedToggle={endTimeAmPm}
          onToggle={(val) => setEndTimeAmPm(val)}
          showErrors={showErrors}
          errorMessage={errorMessage}
        >
        </TimeRange>
      </div>
    </Modal>
  )
}

export default AddManageRangeTimeModal
